"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.migrateToV1 = void 0;

var migrateToV1 = function migrateToV1(apiResponse) {
  if (apiResponse && apiResponse.data && apiResponse.data.result) {
    var _merchant_account$pro;

    var _ref = apiResponse.data.result.onboardingResponse || {
      merchant_account: {}
    },
        merchant_account = _ref.merchant_account;

    var payHandleResponse = apiResponse.data.result.payHandleResponse || '';
    var settlementResponse = apiResponse.data.result.settlementResponse || {};
    apiResponse.data.result = {
      uuid: merchant_account.uuid,
      businessEntityName: merchant_account.business_entity_name,
      businessOrigin: merchant_account.business_origin,
      csPlan: merchant_account.cs_plan,
      email: merchant_account.email,
      gstNumber: merchant_account.gst_number,
      integrationType: merchant_account.integration_type,
      isCsEligible: merchant_account.is_cs_eligible,
      logo: merchant_account.logo,
      merchantType: merchant_account.merchant_type,
      migrationStatus: merchant_account.migration_status,
      mobile: merchant_account.mobile,
      name: merchant_account.name,
      nbEligible: merchant_account.nb_eligible,
      switchPayEnabled: merchant_account.switchpay_enabled,
      offerEngineEnabled: merchant_account.offer_engine_enabled,
      onboardingStatus: merchant_account.onboarding_completed,
      paymentHandle: payHandleResponse,
      pendingAddendums: merchant_account.pending_addendums,
      signature: merchant_account.signature,
      attachedConfigs: merchant_account.attached_configs,
      status: {
        settlementOnHold: settlementResponse.settlementStatus,
        payoutEnabled: merchant_account.payout_enabled,
        onboardingCompleted: merchant_account.onboarding_completed,
        mcpApprovalStatus: (merchant_account === null || merchant_account === void 0 ? void 0 : (_merchant_account$pro = merchant_account.product_account_detail) === null || _merchant_account$pro === void 0 ? void 0 : _merchant_account$pro.mcp_approval_status) || null
      },
      onboardingResponse: merchant_account,
      payHandleResponse: payHandleResponse,
      settlementResponse: settlementResponse
    };
  }

  return apiResponse;
};

exports.migrateToV1 = migrateToV1;